var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bx_soa_location row" }, [
    _c(
      "div",
      { staticClass: "col-xs-12" },
      [
        _vm._l(_vm.locations, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "form-group bx-soa-location-input-container",
              attrs: { "data-property-id-row": index },
            },
            [
              _c(
                "label",
                {
                  staticClass: "bx-soa-custom-label",
                  attrs: { for: "soa-property-" + index },
                },
                [
                  _c("span", { staticClass: "bx-authform-starrequired" }, [
                    _vm._v("*"),
                  ]),
                  _vm._v(" Город "),
                  _c("br"),
                  _c("small", [
                    _vm._v(
                      "(Выберите ваш город, чтобы мы могли рассчитать доставку)"
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.defaultLocations
                ? _c(
                    "div",
                    { staticClass: "default-loc" },
                    _vm._l(_vm.defaultLocations, function (oneDef) {
                      return _c(
                        "div",
                        {
                          staticClass: "one-def-loc",
                          on: {
                            click: function ($event) {
                              return _vm.changeLocation(oneDef, item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                                " +
                              _vm._s(oneDef.NAME) +
                              "\n                                        "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bx-sls", attrs: { id: item.template } },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "dropdown-block bx-ui-sls-input-block form-control",
                    },
                    [
                      _c("span", { staticClass: "dropdown-icon" }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "dropdown-field",
                        staticStyle: { display: "none" },
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          name: "ORDER_PROP_" + index,
                          placeholder: "Введите название ...",
                        },
                        domProps: { value: item.lastValue },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bx-ui-sls-container",
                          staticStyle: {
                            margin: "0px",
                            padding: "0px",
                            border: "none",
                            position: "relative",
                          },
                        },
                        [
                          _c("input", {
                            staticClass: "bx-ui-sls-route",
                            staticStyle: { padding: "0px", margin: "0px" },
                            attrs: {
                              type: "text",
                              disabled: "disabled",
                              autocomplete: "off",
                            },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.input_location,
                                expression: "input_location",
                              },
                            ],
                            staticClass: "bx-ui-sls-fake",
                            attrs: {
                              type: "text",
                              autocomplete: "off",
                              value: "",
                              placeholder: "Введите название ...",
                            },
                            domProps: { value: _vm.input_location },
                            on: {
                              keyup: function ($event) {
                                return _vm.getLocation($event)
                              },
                              focus: _vm.focusInput,
                              "~focus": function ($event) {
                                return _vm.focusInputOnce.apply(null, arguments)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.input_location = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "delete",
                            on: { click: _vm.clearField },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-fade2white" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "bx-ui-sls-loader" }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bx-ui-sls-clear",
                        staticStyle: { display: "none" },
                        attrs: { title: "Отменить выбор" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bx-ui-sls-pane",
                          class: { active: _vm.get_locations.length > 0 },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "bx-ui-sls-variants" },
                            _vm._l(
                              _vm.get_locations,
                              function (item_loc, index) {
                                return _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-item bx-ui-sls-variant",
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeLocation(
                                          item_loc,
                                          item
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "dropdown-item-text" },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(item_loc.DISPLAY)),
                                        ]),
                                        _vm._v(
                                          ", \n                                                    " +
                                            _vm._s(item_loc.PATH_DISPLAY) +
                                            "\n                                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "bx-ui-sls-error-message" }),
                ]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "hidden", name: "RECENT_DELIVERY_VALUE", value: "" },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }